export const REVIEWS_TOKEN_LOADING = 'waitrose/reviews/REVIEWS_TOKEN_LOADING';
export const REVIEWS_TOKEN_LOADED = 'waitrose/reviews/REVIEWS_TOKEN_LOADED';
export const REVIEWS_TOKEN_FAILED = 'waitrose/reviews/REVIEWS_TOKEN_FAILED';
